import React from "react";
import eyeImg from "assets/icons/eyeIcon.svg";
import { formatDate } from "helper/dateFormat";
import { Avatar, Collapse } from "@material-ui/core";
import { Box, Typography, IconButton } from "@material-ui/core";

const EventCard = ({
  event,
  idx,
  color,
  isExpanded,
  onToggle,
  type,
  classes,
  handleEvent,
}) => {
  return (
    <Box
      key={idx}
      className={classes.card}
      style={{ backgroundColor: color.bg }}
    >
      <Typography
        className={classes.title}
        style={{ color: color.text, cursor: "pointer" }}
        onClick={() => onToggle(type, idx)}
      >
        {event?.name}
      </Typography>
      <Typography className={classes.date}>
        {formatDate({ date: event?.theDate, formatType: "default" })}
      </Typography>
      <IconButton
        className={classes.dotButton}
        size="small"
        style={{ color: color.text }}
        onClick={() => handleEvent(event)}
        sx={{ width: 30, height: 35 }}
      >
        <img src={eyeImg} alt="eye" width={18} />
      </IconButton>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <>
          <Typography className={classes.updateText}>
            {event.last_update_text ? "Last Update" : "Added"}
          </Typography>

          <Typography className={classes.updateDes}>
            {event.last_update_text ?? event?.memo}
          </Typography>

          <Box className={classes.updatedInfo}>
            <Avatar src={event?.avatar} style={{ width: 20, height: 20 }} />
            <Typography className={classes.updateTime}>
              {formatDate({
                date: event?.last_update_date ?? event?.added,
                formatType: "default",
              })}{" "}
              by {event?.last_update_by ?? event?.changed_by}
            </Typography>
          </Box>
        </>
      </Collapse>
    </Box>
  );
};
export default EventCard;
